/**
 * Normaliza `expiresIn` del API de autenticación a timestamp absoluto (ms).
 *
 * El contrato de Simappe entrega `expiresIn` en **milisegundos**: el oauth2 responde
 * `SimappeToken.expiresIn = application.jwt.expiration-time`, que se configura en ms y es la
 * misma magnitud con la que el servidor construye el `exp` del JWT. Interpretarlo como segundos
 * multiplicaba la vigencia por mil, así que el refresco programado caía fuera de la jornada y la
 * sesión solo descubría el vencimiento al chocar contra un 401.
 */
export function resolveTokenExpiryTimestamp(expiresIn: number | undefined | null): number | null {
  if (expiresIn == null || !Number.isFinite(expiresIn) || expiresIn <= 0) {
    return null;
  }

  // Algunos emisores mandan el vencimiento ya resuelto como epoch en ms en vez de una duración.
  if (expiresIn > 1e12) {
    return expiresIn;
  }

  return Date.now() + expiresIn;
}
